export default __webpack_public_path__ + "static/media/phone.2a04533d.svg";